<template>
  <div class="grid w-full h-full">
    <div class="absolute inset-0 overflow-auto text-sm text-center 2xl:items-center">
      <transition name="fade" mode="out-in">
        <div v-if="units.length > 0" class="flex w-full h-full">
          <table width="100%" height="100%" class="overflow-hidden text-white bg-gray-700 border border-gray-700">
            <tr>
              <td rowspan="2" class="border border-gray-200 border-opacity-30">
                &nbsp;
              </td>
              <td v-for="n in maxRoom" :key="n" class="p-1 border border-gray-200 border-opacity-30">
                {{ n.toString().padStart(2, '0') }}
              </td>
            </tr>
            <tr>
              <td colspan="4" class="p-1 border border-gray-200 border-opacity-30">
                Airport View
              </td>
              <td colspan="3" class="p-1 border border-gray-200 border-opacity-30">
                Central View
              </td>
              <td colspan="6" class="p-1 border border-gray-200 border-opacity-30">
                City View
              </td>
              <td colspan="9" class="p-1 border border-gray-200 border-opacity-30">
                Kho Hong View
              </td>
              <td class="p-1 border border-gray-200 border-opacity-30">
                Airport View
              </td>
            </tr>
            <tr v-for="floor in units" :key="floor.floor">
              <td class="p-1 text-right border border-gray-200 border-opacity-30">
                {{ floor.floor.padStart(3, '0') }}
              </td>
              <td
                v-for="unit in floor.units"
                :key="unit.UnitNumber"
                :class="{
                  'bg-red-500': ['1', '2', '6'].includes(unit.UnitStatus),
                  'bg-green-500': unit.UnitStatus === '0',
                  'bg-gray-500': unit.UnitStatus === '3',
                  'bg-black': !unit.UnitStatus,
                }"
                class="p-1 text-white border border-gray-200 border-opacity-30"
              >
                {{ unit.UnitNumber }}
              </td>
            </tr>
          </table>
        </div>
        <div v-else class="flex items-center justify-center w-full h-full">
          <svg class="w-8 h-8 text-black animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Matrix',
  data () {
    return {
      units: [],
      maxRoom: 23,

      timer: undefined,
      isLoading: false,
    }
  },
  activated () {
    this.fetch()
    this.setTimer()
  },
  mounted () {
    this.fetch()
    this.setTimer()
  },
  methods: {
    async fetch () {
      this.isLoading = true

      try {
        const { data } = await this.$axios.post(process.env.VUE_APP_API_URL, { projectid: process.env.VUE_APP_API_PROJECT_ID })
        const group = _.groupBy(data.data, unit => unit.UnitNumber.match(/^([0-9A]{1,3})/)[1].replace('0', ''))

        this.units = Object.keys(group).map(floor => {
          const units = []

          for (let i = 1; i <= this.maxRoom; i++) {
            const unit = group[floor].find(unit => new RegExp(`(${i.toString().padStart(2, '0')})$`).test(unit.UnitNumber)) || {}
            units.push(unit)
          }

          return {
            floor,
            units,
          }
        })

        this.units = _.sortBy(this.units, ['floor']).reverse()
      } catch {
        //
      } finally {
        this.isLoading = false

        this.setTimer()
      }
    },
    setTimer () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.fetch()
      }, 15000)
    },
  },
}
</script>
